(function () {
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner || !window.Shopify || !window.Shopify.loadFeatures) return;

  var mainView = banner.querySelector('[data-cookie-banner-view="main"]');
  var settingsView = banner.querySelector('[data-cookie-banner-view="settings"]');
  var settingsToggle = banner.querySelector('[data-cookie-banner-action="open-settings"]');
  var toggles = banner.querySelectorAll('[data-cookie-banner-category]');
  var privacy;

  function hide() {
    banner.hidden = true;
  }

  function showSettings(isOpen) {
    settingsView.hidden = !isOpen;
    mainView.hidden = isOpen;
    settingsToggle.setAttribute('aria-expanded', String(isOpen));
    if (isOpen) toggles[0].focus();
  }

  function syncToggles() {
    var consent = privacy.currentVisitorConsent();
    toggles.forEach(function (toggle) {
      var key = toggle.getAttribute('data-cookie-banner-category');
      var shopifyKey = key === 'statistics' ? 'analytics' : key;
      toggle.checked = consent[shopifyKey] === 'yes';
    });
  }

  function save(choice) {
    privacy.setTrackingConsent(
      {
        analytics: choice.statistics,
        preferences: choice.preferences,
        marketing: choice.marketing,
        sale_of_data: choice.marketing,
      },
      hide
    );
  }

  function open(withSettings) {
    syncToggles();
    banner.hidden = false;
    showSettings(withSettings);
  }

  banner.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cookie-banner-action]');
    if (!button) return;

    var action = button.getAttribute('data-cookie-banner-action');
    if (action === 'accept-all') save({ preferences: true, statistics: true, marketing: true });
    if (action === 'necessary-only') save({ preferences: false, statistics: false, marketing: false });
    if (action === 'open-settings') {
      syncToggles();
      showSettings(true);
    }
  });

  settingsView.addEventListener('submit', function (event) {
    event.preventDefault();
    var choice = {};
    toggles.forEach(function (toggle) {
      choice[toggle.getAttribute('data-cookie-banner-category')] = toggle.checked;
    });
    save(choice);
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href$="#cookie-settings"]');
    if (!link || !privacy) return;
    event.preventDefault();
    open(true);
  });

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    privacy = window.Shopify.customerPrivacy;

    var consent = privacy.currentVisitorConsent();
    var isUndecided = consent.analytics === '' && consent.marketing === '' && consent.preferences === '';

    if (privacy.shouldShowBanner() && isUndecided) open(false);
  });
})();
